module.exports = __webpack_public_path__ + "img/domestic-2012-training.905f8f1b.jpg";